module.exports = require("core-js/library/fn/object/keys");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/object/keys.js
// module id = 488
// module chunks = 0